var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveVerticleUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verticle up down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 8.75C9.91202 8.75 10.1472 9.22038 9.9 9.55L7.4 12.8833C7.2 13.15 6.8 13.15 6.6 12.8833L4.1 9.55C3.85279 9.22038 4.08798 8.75 4.5 8.75L9.5 8.75Z",
    fill: "#F04545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.25C4.08798 5.25 3.85279 4.77962 4.1 4.45L6.6 1.11667C6.8 0.85 7.2 0.85 7.4 1.11667L9.9 4.45C10.1472 4.77962 9.91202 5.25 9.5 5.25L4.5 5.25Z",
    fill: "#F04545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveVerticleUpDown);
export default __webpack_public_path__ + "static/media/inactive-verticle-up-down.78d95863cee339c945c49a24a3098f3d.svg";
export { ForwardRef as ReactComponent };